import React, { useEffect } from 'react';
import { Box, Paper, Typography, Button, Divider } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import logoCoordinadora from '../../../../assets/images/logo-coordinadora.png';
import avionImage from '../../../../assets/images/fondo.webp';

// Componente SVG personalizado para el logo oficial de Google
const GoogleLogo = () => (
  <svg width="20" height="20" viewBox="0 0 48 48" style={{ marginRight: '8px' }}>
    <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.7 17.74 9.5 24 9.5z" />
    <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z" />
    <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z" />
    <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z" />
    <path fill="none" d="M0 0h48v48H0z" />
  </svg>
);

export const LoginPage: React.FC = () => {
  const auth = useAuth();
  const navigate = useNavigate();

  // Si el usuario ya está autenticado, redirigirlo a la selección de terminal
  useEffect(() => {
    if (auth.isAuthenticated) {
      navigate('/select-terminal');
    }
  }, [auth.isAuthenticated, navigate]);

  const handleLogin = () => {
    // Usamos la librería oficial para iniciar el flujo de login (maneja PKCE automáticamente)
    auth.signinRedirect({
      extraQueryParams: { kc_idp_hint: 'google' }
    });
  };

  return (
    <Box
      sx={{
        height: '100vh',
        width: '100vw',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        // Imagen de un avión grande volando entre nubes, sin bordes blancos
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${avionImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        margin: 0,
        padding: 0,
        overflow: 'hidden'
      }}
    >
      <Paper
        elevation={24}
        sx={{
          p: 5,
          width: '100%',
          maxWidth: 450,
          borderRadius: 3,
          textAlign: 'center',
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(10px)',
        }}
      >
        {/* Logo Real de Coordinadora */}
        <Box sx={{ mb: 1, display: 'flex', justifyContent: 'center' }}>
          <img 
            src={logoCoordinadora} 
            alt="Coordinadora Logo" 
            style={{ 
              maxWidth: '280px', 
              height: 'auto',
              objectFit: 'contain'
            }} 
          />
        </Box>
        
        <Divider sx={{ my: 3 }} />

        <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 1, color: '#333' }}>
          Bienvenido
        </Typography>
        
        <Typography variant="body2" sx={{ color: '#666', mb: 4, px: 2 }}>
          Autentícate para acceder al ecosistema digital de aplicaciones de Coordinadora.
        </Typography>

        {/* Botón de Google con el logo SVG oficial */}
          <Button
            variant="contained"
            color="secondary"
            fullWidth
            onClick={handleLogin}
            sx={{
              py: 1.5,
              mb: 1,
              borderRadius: 8,
              textTransform: 'none',
              fontWeight: 'bold',
              fontSize: '1rem',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <GoogleLogo />
            Iniciar sesión con Google
          </Button>
      </Paper>
    </Box>
  );
};
